import { render, staticRenderFns } from "./SchoolAdmin.vue?vue&type=template&id=a75928f8&scoped=true"
import script from "./SchoolAdmin.vue?vue&type=script&lang=js"
export * from "./SchoolAdmin.vue?vue&type=script&lang=js"
import style0 from "./SchoolAdmin.vue?vue&type=style&index=0&id=a75928f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75928f8",
  null
  
)

export default component.exports